import { render } from "./DeletePointExcludedProductCode.vue?vue&type=template&id=752463b1&scoped=true&ts=true"
import script from "./DeletePointExcludedProductCode.vue?vue&type=script&lang=ts"
export * from "./DeletePointExcludedProductCode.vue?vue&type=script&lang=ts"

import "./DeletePointExcludedProductCode.vue?vue&type=style&index=0&id=752463b1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752463b1"]])

export default __exports__